import type { ElementProps } from "../types";
import S from "./Button.module.scss";

export const ButtonElement = ({ template, innerRef }: ElementProps) => {
  return (
    <div className={S.buttonWrapper}>
      <div
        className={S.button}
        contentEditable
        ref={(innerRef as React.RefObject<HTMLDivElement>) ?? undefined}
        dangerouslySetInnerHTML={{ __html: template.text }}
      />
      {template.divider && <div className={S.buttonDivider} />}
    </div>
  );
};
